const projects = {
  projects: {
    header: {
      overline: "PORTFOLIO & RESEARCH",
      titlePrefix: "Innovative",
      titleHighlight: "Solutions",
      subtitle: "A collection of production-ready projects and experimental R&D labs pushing the boundaries of AI.",
    },
    tabs: {
      all: "All",
      projects: "Projects",
      labs: "Labs",
    },
    card: {
      code: "Code",
      demo: "Demo",
    },
    cta: {
      titlePrefix: "Ready to Build Your",
      titleHighlight: "AI Vision?",
      subtitle:
        "Whether it's a production project or an experimental lab, I help you transform complex data into intelligent solutions.",
      primaryButton: "Start a Project",
      secondaryButton: "View Services",
    },
  },
};

export default projects;
